import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const invite = sp.get("invite");
  const invitedEmail = sp.get("email") || "";
  const [name, setName] = useState("");
  const [email, setEmail] = useState(invitedEmail);
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(invite ? "athlete" : "athlete");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, email, password, role);
      if (invite && role === "athlete") {
        try {
          const r = await api.post(`/invites/${invite}/accept`);
          toast.success(`Account created — linked with ${r.data.coach_name}`);
        } catch (er) { toast.success("Account created"); toast.error(er?.response?.data?.detail || "Could not accept invite"); }
      } else {
        toast.success("Account created");
      }
      nav(role === "coach" ? "/coach" : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto mt-10">
      <div className="rs-underline mb-4" />
      <h1 className="font-display-heavy text-4xl mb-6">CREATE YOUR ACCOUNT</h1>
      <form onSubmit={submit} className="space-y-5 bg-neutral-900 border border-neutral-800 rounded-md p-6">
        <div className="space-y-2">
          <Label className="text-base">I'm signing up as</Label>
          <div className="grid grid-cols-2 gap-2">
            {[["athlete", "Athlete"], ["coach", "Coach"]].map(([v, l]) => (
              <button key={v} type="button" data-testid={`signup-role-${v}`} onClick={() => setRole(v)}
                className={`h-12 rounded-md border font-display font-semibold uppercase tracking-wide transition-colors ${role === v ? "bg-red-600 border-red-600 text-white" : "bg-neutral-950 border-neutral-700 text-neutral-300 hover:border-neutral-500"}`}>
                {l}
              </button>
            ))}
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="name" className="text-base">Name</Label>
          <Input data-testid="signup-name-input" id="name" required value={name} onChange={(e) => setName(e.target.value)} className="h-12 bg-neutral-950 border-neutral-700" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email" className="text-base">Email</Label>
          <Input data-testid="signup-email-input" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 bg-neutral-950 border-neutral-700" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password" className="text-base">Password (6+ chars)</Label>
          <Input data-testid="signup-password-input" id="password" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 bg-neutral-950 border-neutral-700" />
        </div>
        <Button data-testid="signup-submit-btn" disabled={busy} className="w-full h-12 bg-red-600 hover:bg-red-700 font-semibold">{busy ? "Creating…" : "Create account"}</Button>
        <p className="text-sm text-neutral-400 text-center">Have an account? <Link data-testid="signup-goto-login" to="/login" className="text-red-500 font-semibold hover:underline">Log in</Link></p>
      </form>
    </div>
  );
}
